<div class="c-container">
    <div class="c-container__header">
        <img src="../../../../assets/madero-logo.svg" alt="" srcset="">
        <h1>reservas</h1>
        <hr>
    </div>
    <div class="c-container__content">
        <img class="c-container__content--image" src="../../../assets/images/avatar.png">
        @if(isConfirmed == null){
            @if(errorService == true){
                <h1>Ocorreu um erro ao alterar a reserva!</h1>
                <h3>Entre em contato com o restaurante.</h3>
            }@else{
                <div class="c-spinner">
                    <mat-spinner></mat-spinner>
                </div>
            }
        }@else if(isConfirmed == true){
            <h1 class="c-container__content--title confirmed">
                <mat-icon class="material-symbols-rounded c-container__content--icon"> task_alt </mat-icon>
                <span>Reserva <b>CONFIRMADA</b> com sucesso!</span>
            </h1>
        }@else if(isConfirmed == false){
            <h1 class="c-container__content--title cancel">
                <mat-icon class="material-symbols-rounded c-container__content--icon"> task_alt </mat-icon>
                <span>Reserva <b>CANCELADA</b>!</span>
            </h1>            
        }
    </div>
</div>